import { Location } from '@cobliteam/common-types';
import { Redirect } from 'react-router-dom';

const SafetyRankingRedirectPage = () => {
  return <Redirect to={Location.SAFETY_RANKING_VEHICLE} />;
};

export default SafetyRankingRedirectPage;
